<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.ADD_SESSION.TITLE') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="formValid">
          <v-col cols="12">
            <v-select
              v-model="selectedPlace"
              :items="availablePlaces"
              :value="selectedPlace"
              :item-text="'Name'"
              append-outer-icon="mdi-map-marker"
              return-object
              :menu-props="{ bottom: true, offsetY: true }"
              outlined
              hide-details
              :label="$vuetify.lang.t('$vuetify.DASHBOARD.PLACE')"
              required
              :loading="!availablePlaces.length && loading.state"
            >
            </v-select>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="licencePlate"
              :label="$vuetify.lang.t('$vuetify.CAR_NUMBER')"
              outlined
              append-outer-icon="mdi-car"
              :rules="licencePlateRules"
              required
            ></v-text-field>
          </v-col>
          <v-col
            v-if="
              selectedPlace &&
                selectedPlace.DefaultMinutes &&
                selectedPlace.DefaultMinutes > 0
            "
            cols="12"
            class="row"
          >
            <span>
              {{
                `${$vuetify.lang.t(
                  '$vuetify.FLEETS.DEFAULT_MINUTES_INFORMATION'
                )} ${selectedPlace.DefaultMinutes}`
              }}
            </span>
          </v-col>
          <v-col
            v-if="selectedPlace && !selectedPlace.HasGate"
            cols="12"
            class="row"
          >
            <!-- <v-menu offset-y dense>
              <template v-slot:activator="{ on }">
                <v-btn color="secondary" v-on="on">
                  {{
                    selectedHours
                      ? selectedHours
                      : $vuetify.lang.t('$vuetify.ADD_SESSION.HOURS')
                  }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="item in hours"
                  :key="item"
                  dense
                  @click="selectedHours = item"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
            <v-select
              v-model="selectedMinutes"
              :items="minutes"
              :label="$vuetify.lang.t('$vuetify.ADD_SESSION.MINUTES')"
              clearable
              @click:clear="clearSelectedMinutes()"
            ></v-select>
            <v-select
              v-model="selectedHours"
              :items="hours"
              :label="$vuetify.lang.t('$vuetify.ADD_SESSION.HOURS')"
              clearable
              @click:clear="clearSelectedHours()"
            ></v-select>
            <v-select
              v-model="selectedDays"
              :items="days"
              :label="$vuetify.lang.t('$vuetify.ADD_SESSION.DAYS')"
              clearable
              @click:clear="clearSelectedDays()"
            ></v-select>
          </v-col>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary" class="secondary--text"
          :disabled="!formValid"
          @click="
            addSession({
              fleetId: fleetId,
              fleetUserId: fleetUserId,
              placeId: selectedPlace.Id,
              carNumber: licencePlate,
              hours: selectedHours,
              days: selectedDays,
              minutes: selectedMinutes
            })
          "
        >
          {{ $vuetify.lang.t('$vuetify.ADD') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StartFleetSessionDialog',
  props: {
    fleetId: {
      type: Number,
      required: true
    },
    fleetUserId: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      formValid: true,
      availablePlaces: [],
      selectedPlace: null,
      licencePlate: '',
      licencePlateRules: [v => v.length >= 2 || 'Autonumber on nõutud'],
      minutes: [0, 15, 30, 45],
      hours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      days: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30
      ],
      selectedHours: 0,
      selectedDays: 0,
      selectedMinutes: 0,
      inputsDisabled: false,
      defaultHours: 0
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.availablePlaces = []
          this.selectedPlace = null
          this.licencePlate = ''
          this.$emit('close')
        }
      }
    }
  },
  watch: {
    currentFleedId(newValue) {
      if (newValue !== null || newValue === 0 || newValue <= 0) {
        this.getAvailablePlaces()
      }
    },
    selectedPlace(newValue) {
      if (newValue && newValue.DefaultMinutes && newValue.DefaultMinutes > 0) {
        this.clearSelectedMinutes()
        this.clearSelectedHours()
        this.clearSelectedDays()

        const minutes = newValue.DefaultMinutes % 60
        this.minutes.push(minutes)
        const hours = Math.floor((newValue.DefaultMinutes / 60) % 24)
        const days = Math.floor(newValue.DefaultMinutes / (60 * 24))

        this.selectedMinutes = minutes
        this.selectedHours = hours
        this.selectedDays = days
      } else if (this.defaultHours && this.defaultHours > 0) {
        this.clearSelectedMinutes()
        this.clearSelectedHours()
        this.clearSelectedDays()
        this.selectedHours = this.defaultHours
      }
    }
  },
  mounted() {
    if (!this.selectedPlace) {
      this.getAvailablePlaces()
    }
  },
  methods: {
    ...mapActions('fleets', ['startNewSession', 'getInfoForSessionStart']),
    async getAvailablePlaces() {
      if (
        this.fleetUserId !== null &&
        this.fleetId !== null &&
        !this.availablePlaces.length
      ) {
        const sessionInfo = await this.getInfoForSessionStart({
          fleetId: this.fleetId,
          fleetUserId: this.fleetUserId
        })
        if (sessionInfo.data.DefaultHours) {
          this.defaultHours = sessionInfo.data.DefaultHours
          this.selectedHours = this.defaultHours
        }
        if (sessionInfo.data.Places) {
          this.availablePlaces = []
          this.availablePlaces = sessionInfo.data.Places
          // eslint-disable-next-line prefer-destructuring
          this.selectedPlace = sessionInfo.data.Places[0]
        } else {
          this.availablePlaces = []
          this.selectedPlace = null
        }
      }
    },
    addSession(payload) {
      try {
        this.startNewSession(payload)
        this.$emit('close')
        this.$emit('did-add-session')
      } catch (error) {
        this.$emit('close')
      }
    },
    clearSelectedDays() {
      this.selectedDays = 0
    },
    clearSelectedHours() {
      this.selectedHours = 0
    },
    clearSelectedMinutes() {
      this.selectedMinutes = 0
    }
  }
}
</script>
